/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-4
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {getSearchBodyUrl, loadAndDisplayFetchResult} from './search-common.js';
import {handleSwitch} from './search-switch.js';

/**
 * Change la page de résultat de recherche.
 * @param e {Event} - L'événement de clic.
 * @param link {HTMLAnchorElement} - Le lien de la page à afficher.
 * @returns {Promise<void>} - Une promesse.
 */
async function changeResultPage(e, link) {
    e.preventDefault();
    const url = new URL(link.href);
    const fetchUrl = new URL(`${getSearchBodyUrl()}?${url.searchParams}`, window.location);
    await loadAndDisplayFetchResult(fetchUrl, 'search-body');
    handleSwitch();
    handlePaginationActions();
    const component = document.getElementById('component-search');
    if (component) {
        component.scrollIntoView();
    }
}

/**
 * Bind l'événement click sur un lien de pagination.
 * @param {HTMLElement} link - Le lien de pagination
 */
function bindPaginationLink(link) {
    // Vérifier si l'événement n'est pas déjà bindé
    if (!link.hasAttribute('data-pagination-bound')) {
        link.setAttribute('data-pagination-bound', 'true');
        link.addEventListener('click', async (e) => {
            await changeResultPage(e, link);
        });
    }
}

/**
 * Gère les actions de pagination - bind les éléments existants.
 */
export function handlePaginationActions() {
    const paginationLinks = document.querySelectorAll('#search-pagination .pagination__link');
    paginationLinks.forEach(bindPaginationLink);
}

/**
 * Observe les changements dans le DOM pour auto-binder les nouveaux liens de pagination.
 */
function initPaginationObserver() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Vérifier les nœuds ajoutés
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.closest('#search-pagination')) {
                    // Si le nœud lui-même est un lien de pagination
                    if (node.classList && node.classList.contains('pagination__link')) {
                        bindPaginationLink(node);
                    }
                    // Si le nœud contient des liens de pagination
                    const paginationLinks = node.querySelectorAll ? node.querySelectorAll('.pagination__link') : [];
                    paginationLinks.forEach(bindPaginationLink);
                }
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    return observer;
}

initPaginationObserver();
